import ScrollMagic from 'scrollmagic';
import 'debug.addIndicators';

export default new ScrollMagic.Controller();



// WEBPACK FOOTER //
// ./scripts/utils/scrollmagic/controller.js